import { getDifferenceInMinutes } from '@weenat/client/dist/core/history'
import {
  CheckInWindowMinutes,
  DangerThresholdMinutes,
  getLastUpdateDelaySeverityLevel,
  SEVERITY_COLOR_FOR_BADGES
} from '@weenat/client/dist/enums/Devices'
import { isNaN, isNil } from 'lodash-es'
import Badge from './Badge'
import { LastUpdateProps } from './LastUpdate'
import LastUpdatePrimitive from './LastUpdatePrimitive'

const LastUpdateBadge: FC<LastUpdateProps> = ({
  timestamp,
  warningThreshold,
  dangerThreshold,
  timezone
}) => {
  //used to distinguish between vws badges without drilling props through multiple component at several locations
  //this is a valid check because vws has specific thresholds - might have to reconsider if this changes
  const isVWSBadge =
    (warningThreshold as CheckInWindowMinutes) === CheckInWindowMinutes.smv &&
    (dangerThreshold as DangerThresholdMinutes) === DangerThresholdMinutes.smv

  // Easier for types to handle it this way
  if (isNil(timestamp) || isNaN(timestamp)) {
    return <LastUpdatePrimitive timestamp={null} timezone={undefined} />
  }

  const minutesSinceLastUpdate = getDifferenceInMinutes(timestamp)

  const severity = getLastUpdateDelaySeverityLevel(
    minutesSinceLastUpdate,
    warningThreshold,
    dangerThreshold
  )

  const backgroundColor = SEVERITY_COLOR_FOR_BADGES[severity]

  return (
    <Badge $backgroundColor={backgroundColor} $borderRadius={'sm'} $py={'xs'} $px={'xs'}>
      <LastUpdatePrimitive
        timestamp={timestamp}
        color={severity === 'danger' ? 'grayscale.white' : 'grayscale.black'}
        timezone={timezone}
        isVWSBadge={isVWSBadge}
      />
    </Badge>
  )
}

export default LastUpdateBadge
